import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Signup() {
  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { signup, login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (form.password !== form.confirmPassword) {
        setError('Passwords do not match.');
        return;
      }
      if (form.password.length < 8 || !/[A-Z]/.test(form.password) || !/[0-9]/.test(form.password)) {
        setError('Password must be at least 8 characters and include one uppercase letter and one number.');
        return;
      }
      await signup(form.email, form.password);
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>Transformation Companion</div>
        <div style={styles.tagline}>Coaching & Counseling</div>

        <h2 style={styles.title}>Create your account</h2>
        <p style={styles.subtitle}>Start your private beta access</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              style={styles.input}
              placeholder="you@example.com"
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              style={styles.input}
              placeholder="At least 8 characters"
              minLength={8}
              required
            />
            <div style={styles.hint}>At least 8 characters, including one uppercase letter and one number.</div>
            <input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              style={{ ...styles.input, marginTop: '10px' }}
              placeholder="Confirm password"
              required
            />
          </div>
          <div style={styles.notice}>
            🔒 Your client data is stored securely and privately. We never share or sell your data.
          </div>

          <button
            type="submit"
            style={{...styles.btn, opacity: loading ? 0.7 : 1}}
            disabled={loading}
          >
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>

        <p style={styles.footer}>
          Already have an account?{' '}
          <Link to="/login" style={styles.link}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#F8F5F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Figtree', sans-serif",
    padding: '20px',
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '420px',
    border: '1px solid #D8E0DC',
    boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
  },
  logo: {
    fontFamily: 'Georgia, serif',
    fontSize: '24px',
    fontWeight: '300',
    fontStyle: 'italic',
    color: '#C4956A',
    marginBottom: '4px',
  },
  tagline: {
    fontSize: '11px',
    color: '#8C9E98',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: '32px',
  },
  title: {
    fontSize: '22px',
    fontWeight: '500',
    color: '#2D3A35',
    marginBottom: '6px',
  },
  subtitle: {
    fontSize: '13.5px',
    color: '#8C9E98',
    marginBottom: '24px',
  },
  formGroup: {
    marginBottom: '18px',
  },
  label: {
    display: 'block',
    fontSize: '12px',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    color: '#8C9E98',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    borderRadius: '8px',
    border: '1px solid #D8E0DC',
    background: '#F8F5F0',
    fontFamily: "'Figtree', sans-serif",
    fontSize: '14px',
    color: '#2D3A35',
    outline: 'none',
    boxSizing: 'border-box',
  },
  btn: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    background: '#5C7A6B',
    color: 'white',
    fontFamily: "'Figtree', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    marginTop: '8px',
  },
  hint: {
    fontSize: '11.5px',
    color: '#8C9E98',
    marginTop: '6px',
    lineHeight: 1.5,
  },
  notice: {
    background: '#EBF0ED',
    color: '#5C7A6B',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '12.5px',
    marginBottom: '16px',
  },
  error: {
    background: '#F5EAEA',
    color: '#B85C5C',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '13.5px',
    marginBottom: '16px',
  },
  footer: {
    textAlign: 'center',
    fontSize: '13.5px',
    color: '#8C9E98',
    marginTop: '24px',
  },
  link: {
    color: '#5C7A6B',
    textDecoration: 'none',
    fontWeight: '500',
  },
  confirmIcon: {
    fontSize: '48px',
    textAlign: 'center',
    marginBottom: '16px',
  },
  confirmText: {
    fontSize: '14px',
    color: '#4A5A54',
    lineHeight: 1.7,
    textAlign: 'center',
    marginBottom: '12px',
  },
  confirmSub: {
    fontSize: '13px',
    color: '#8C9E98',
    textAlign: 'center',
    marginBottom: '24px',
  },
  confirmBtn: {
    display: 'block',
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    background: '#5C7A6B',
    color: 'white',
    textAlign: 'center',
    textDecoration: 'none',
    fontFamily: "'Figtree', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '16px',
    boxSizing: 'border-box',
  },
  confirmResend: {
    fontSize: '12.5px',
    color: '#8C9E98',
    textAlign: 'center',
  },
};